<template>
  <div>
    <h1 class="title is-4 mb-6">Confirmar acción masiva</h1>
    <label class="font-bold">Acción masiva: {{ action.title }}</label>

    <div class="panel">
      <p v-if="action.name === 'assign_manager'">La acción asignará a {{ linkedEntities.length }} usuario como responsable de {{ activities.length }} actividad/es</p>
      <p v-else-if="action.name === 'assign_participants'">La acción asignará a {{ linkedEntities.length }} participante/s a {{ activities.length }} actividad(es) seleccionada(s)</p>
      <p v-else-if="action.name === 'assign_collaborators'">La acción asignara a {{ linkedEntities.length }} colaborador/es a {{ activities.length }} actividad(es) seleccionada(s)</p>
      <p v-else-if="action.name === 'assign_tracking_user'">La acción asignara a {{ linkedEntities.length }} usuario/s de seguimiento a {{ activities.length }} actividad(es) seleccionada(s)</p>
      <p v-else-if="action.name === 'link_documents'">La acción vinculará a {{ linkedEntities.length }} documento/s a {{ activities.length }} actividad(es) seleccionada(s)</p>
      <p v-else-if="action.name === 'link_validations'">La acción vinculará a {{ linkedEntities.length }} flujo/s de validacion/es a {{ activities.length }} actividad(es) seleccionada(s)</p>
      <p v-else-if="action.name === 'remove_activities'">Se eliminarán {{ activities.length }} actividad(es) seleccionada(s)</p>
      <p v-else-if="action.name === 'remove_assignments'">  {{ $t('bulk_remove_assignments_msg', { amount: assignments.length }) }}</p>
      <p v-else-if="action.name === 'move_assignments'">
        {{ $t('bulk_move_assignments_msg', { amount: assignments.length, target: linkedEntities[0] ? linkedEntities[0].name : '' }) }}
      </p>

      <div class="flex flex-row mt-3 space-x-4">
        <div class="w-1/2" v-if="action.name !== 'move_assignments'">
          <div v-if="action.name === 'change_data'">
            <p>Datos a ser modificados</p>
            <ul class="max-h-80 overflow-y-auto pr-2">
              <li>
                <p>Fecha actual de inicio: {{ linkedEntities[0].current_start_date }}</p>
              </li>
              <li>
                <p>Fecha actual de finalización: {{ linkedEntities[0].current_end_date }}</p>
              </li>
            </ul>
          </div>
          <div v-else-if="action.name === 'assign_group'">
            <p>Grupo a asignar</p>
            <ul class="max-h-80 overflow-y-auto pr-2">
              <li>
                <p>Nombre grupo: {{ linkedEntities[0].group_name }}</p>
              </li>
            </ul>
          </div>
          <div v-else>
            <p class="mb-2" v-if="action.name === 'assign_manager'">Responsable a asignar</p>
            <p class="mb-2" v-else-if="action.name === 'assign_participants'">Participante(s) a asignar</p>
            <p class="mb-2" v-else-if="action.name === 'assign_collaborators'">Colaborador(es) a asignar</p>
            <p class="mb-2" v-else-if="action.name === 'assign_tracking_user'">Usuario(s) de seguimiento de actividad a asignar</p>
            <p class="mb-2" v-else-if="action.name === 'link_documents'">Documento(s) a vincular</p>
            <p class="mb-2" v-else-if="action.name === 'link_validations'">Validacion(es) a vincular</p>
            <p class="mb-2" v-else-if="action.name === 'link_tags'">Etiquetas a ser vinculadas</p>

            <entity-list
              :entities="linkedEntities"
              :entityKey="entityKey"
              :withImage="withImage"
              :show="true"
              :showRemoveButton="false"
              :componentName="componentName"
            />
          </div>
        </div>
        <template v-if="action.name !== 'remove_assignments' && action.name !== 'move_assignments'">
          <div class="w-1/2" >
            <p class="mb-2">Actividad(es) afectada(s)</p>
            <entity-list
              :entities="[...activities, ...subactivities]"
              entityKey="id"
              :withImage="false"
              :show="true"
              :showRemoveButton="false"
              :componentName="['name']"
            />
          </div>
          <div class="mt-8">
          <p class="mb-4">
            ¿Aplicar acción solo a actividades seleccionadas?
            <b-tooltip position="is-bottom" multilined>
              <b-icon pack="fas"
                  type="is-info"
                  icon="info-circle"
                  size="is-small">
              </b-icon>
              <template v-slot:content>
                  Por defecto la acción se aplica a las actividades padres seleccionadas
                  <b>y todas las subactividades de estas</b>. <br>
                  Marque esta opción si desea que la acción
                  <i>afecte exclusivamente a las actividades y subactividades seleccionadas</i>.
              </template>
          </b-tooltip>

            <b-field>
              <b-switch v-model="applyOnlySelected" type="is-success"></b-switch>
            </b-field>
          </p>
          <p class="font-bold">¿Seguro que desea continuar?</p>
        </div>
        </template>

        <div class="w-1/2" v-else-if="action.name === 'remove_assignments'">
          <p class="mb-2">Medición(es) a eliminar</p>
          <entity-list
            :entities="assignments"
            entityKey="id"
            :withImage="false"
            :show="true"
            :showRemoveButton="false"
            :componentName="['label', 'code']"
          />
        </div>

        <template v-else-if="action.name === 'move_assignments'">
          <div class="w-1/2">
            <p class="mb-2">{{ $t('move_assignments_origin_label') }}</p>
            <div
              v-for="group in moveOriginGroups"
              :key="group.id"
              class="mb-4"
            >
              <div class="flex items-baseline mb-2 text-sm">
                <b-icon pack="fas" icon="folder" size="is-small" class="mr-2 text-grey-darker"></b-icon>
                <span class="font-bold">{{ group.name }}</span>
                <span v-if="group.planning_code" class="text-xs text-grey-darker ml-2">
                  {{ group.planning_code }}
                </span>
                <span class="text-xs text-grey-darker ml-auto">
                  {{ group.assignments.length }}
                </span>
              </div>
              <div class="overflow-hidden">
                <entity-list
                  :entities="group.assignments"
                  entityKey="id"
                  :withImage="false"
                  :show="true"
                  :showRemoveButton="false"
                  :componentName="['label', 'code']"
                />
              </div>
            </div>
          </div>
          <div class="w-1/2">
            <p class="mb-2">{{ $t('move_assignments_destination_label') }}</p>
            <div v-if="linkedEntities[0]" class="border border-grey-lighter rounded p-3 bg-white">
              <div class="flex items-baseline">
                <b-icon pack="fas" icon="folder-open" size="is-small" class="mr-2 text-info"></b-icon>
                <span class="font-bold">{{ linkedEntities[0].name }}</span>
              </div>
              <p v-if="linkedEntities[0].planning_code" class="text-xs text-grey-darker mt-1 ml-6">
                {{ linkedEntities[0].planning_code }}
              </p>
            </div>
          </div>
        </template>
      </div>

      <p v-if="action.name === 'move_assignments'" class="mt-4 text-xs text-grey-darker italic">
        {{ $t('move_assignments_help') }}
      </p>

    </div>
  </div>
</template>

<script>
import Vue from "vue"
import axios from 'axios'
import Form from 'vform'
import moment from 'moment'
import entityList from './utils/entity-list.vue';


export default {
  name: 'wizard-bulk-complete',

  components: {
    entityList
  },

  props: {
    projectId: { type: Number, default: 0 },
    action: { type: Object, required: true },
    activities: { type: Array, required: true },
    subactivities: { type: Array, default: () => [] },
    linkedEntities: { type: Array, required: true },
    assignments: { type: Array, default: () => [] }
  },

  data: () => ({
    form: new Form({ }),
    boxFullWidth: false,
    applyOnlySelected: false,
    submitting: false,
  }),

  mounted() {
  },

  created() {
  },

  watch: {

  },

  computed: {
    withImage() {
      return this.isListUser()
    },

    componentName() {
      return this.getComponentName()
    },

    entityKey() {
      let keyVal = '';
      switch (this.action.name) {
        case 'link_documents':
          keyVal = 'document_id'
          break;

        case 'link_tags':
          keyVal = 'text'
          break;

        default:
          keyVal = 'id'
          break;
      }

      return keyVal
    },

    /**
     * Agrupa las mediciones seleccionadas por su actividad de origen para mostrar
     * de dónde viene cada una en el resumen del traslado.
     */
    moveOriginGroups() {
      const groups = new Map();
      this.assignments.forEach((a) => {
        const id = a.origin_activity_id || a.assignable_id || 0;
        if (!groups.has(id)) {
          groups.set(id, {
            id,
            name: a.origin_activity_name || this.$t('unknown_origin'),
            planning_code: a.origin_planning_code || '',
            assignments: [],
          });
        }
        groups.get(id).assignments.push(a);
      });
      return Array.from(groups.values());
    },
  },

  methods: {
    prepareForm() {

      this.form.activities = this.activities.map((activity) => {
        // return activity.planning_code
        return activity.id
      })

      // añadimos los id de las subactividades si solo se aplica a las actividades selecionadas
      // if(this.applyOnlySelected && this.subactivities.length) {
        let subactivitites = this.subactivities.map((subactivity) => {
          return subactivity.id
        })
        this.form.activities.push(...subactivitites)
      // }

      switch (this.action.name) {
        case 'assign_manager':
        case 'assign_participants':
        case 'assign_collaborators':
        case 'assign_tracking_user':
        case 'remove_manager':
        case 'remove_participants':
        case 'remove_collaborators':
        case 'remove_tracking_user':

          this.form.linkedEntities = this.linkedEntities.map((linkedenty) => {
            return linkedenty.email
          })
          break;

        case 'change_data':
          this.form.linkedEntities = this.linkedEntities
          break;

        case 'link_documents':
        case 'link_validations':
          this.form.linkedEntities = this.linkedEntities.map((linkedenty) => {
            return linkedenty.code
          })

          break;

        case 'link_tags':
          this.form.linkedEntities = this.linkedEntities.map((linkedenty) => {
            return linkedenty.text
          })
          break;

        case 'assign_group':
          this.form.linkedEntities = this.linkedEntities
          break;
        case 'remove_assignments':
          this.form.assignments = this.assignments.map(a => a.id);
          break;

        case 'move_assignments':
          this.form.assignments = this.assignments.map(a => a.id);
          // linkedEntities[0] viene como { id, name, planning_code }
          this.form.linkedEntities = this.linkedEntities;
          break;

        default:
          break;
      }

      this.form.action_type = this.action.type
      this.form.apply_only_selected = this.applyOnlySelected
      
      // Agregar fast_bulk para acciones de asignación de usuarios (tipo 1, 2, 3)
      // 1 assign_manager, 2 assign_participants, 3 assign_collaborators
      if (this.action.type === 1 || this.action.type === 2 || this.action.type === 3) {
        this.form.fast_bulk = 1
      } else {
        this.form.fast_bulk = 0
      }
    },

    async sendForm() {
      if (this.submitting) return;
      this.submitting = true;
      this.prepareForm();
      let url = `/api/v2/project/${this.projectId}/bulk-actions`

      try {
        // Enviamos el form
        const { data } = await this.form.post(url)
        if (data && data.success) {
          // Toast inmediato "en proceso": la acción real corre en background (cola).
          // Cuando termine, el backend dispara la notif BulkAction por Pusher y el
          // listener en Notifications.vue se encarga del toast de "completada" + el
          // EventBus que dispara el refresh de la lista en project-bulk-actions.vue.
          if (this.action.name === 'move_assignments') {
            this.$toast.open({
              message: this.$t('bulk_move_assignments_started'),
              type: 'is-info',
              position: 'is-top-right',
              duration: 4500,
            })
          } else if (this.action.name === 'remove_assignments') {
            this.$toast.open({
              message: this.$t('bulk_remove_assignments_started'),
              type: 'is-info',
              position: 'is-top-right',
              duration: 4500,
            })
          } else {
            this.$notify.success('bulk_action_added_process')
          }
        } else {
          this.$notify.error('error_bulk_action')
        }
      } catch (e) {
        this.$notify.error('error_bulk_action')
      } finally {
        this.submitting = false;
      }
    },

    isListUser() {
      return this.action.name === 'assign_manager' ||
        this.action.name === 'assign_participants' ||
        this.action.name === 'assign_collaborators' ||
        this.action.name === 'assign_tracking_user' ||
        this.action.name === 'remove_manager' ||
        this.action.name === 'remove_participants' ||
        this.action.name === 'remove_collaborators' ||
        this.action.name === 'remove_tracking_user'
    },

    getComponentName() {

      let arrName = [];
      switch (this.action.name) {
        case 'assign_manager':
        case 'assign_participants':
        case 'assign_collaborators':
          arrName = ['name', 'surname']
          break;

        case 'link_tags':
          arrName = ['text']
          break;

        default:
          arrName = ['name']
          break;
      }

      return arrName;
    }
  },
}

      // {value: 1, text: 'assign_manager', title: 'asignación de responsable'},
      // {value: 2, text: 'assign_participants', title: 'asignación de participantes'},
      // {value: 2, text: 'assign_partners', title: 'asignación de colaboradores'},
      // {value: 3, text: 'modify_date_start_end', title: 'cambio de fechas de inicio/fin'},
      // {value: 4, text: 'link_documents', title: 'vinculación de documentos'},
      // {value: 5, text: 'add_validation_flow', title: 'asignación de fluo de validaciones'},
      // {value: 6, text: 'tags', title: 'asignación de etiquetas'},
      // {value: 7, text: 'geolocation', title: 'asignación de geolocalización'},
</script>
